export default __webpack_public_path__ + "static/media/181712.6517a644.jpg";